import Vue from 'vue'
import appConfig from '@/config.js'
import { getCountries, getCountry } from '@/services/country'

// Catálogos del backoffice (MOOV-5198): construcción de params + GET puro.
// Las asignaciones de estado viven en fetches.mixin.js (fachada), que es
// donde los componentes pueden sobreescribir props/fetchers a propósito.

export async function fetchCountries(params) {
  if (!params) {
    params = {
      sort: [
        {
          key: 'name',
          direction: 'asc'
        }
      ]
    }
  }
  return Vue.http.get(appConfig.api.baseUrl + 'countries', { params })
}

// Mismo GET que fetchCountries: en la fachada difieren solo en qué props asignan.
export { fetchCountries as fetchCountriesById }

export async function fetchDeliveryTimeRanges(country = null, includes = []) {
  let params = {}
  country = country || getCountry()
  if (country !== null) {
    const countryId = getCountries().find(x => x.iso_code === country).id
    params = {
      filter_groups: [{
        filters: [
          ['country_id', 'eq', countryId]
        ]
      }]
    }
  }
  if (includes.length > 0) {
    params.includes = includes
  }
  return Vue.http.get(appConfig.api.baseUrl + 'delivery-time-ranges', {params})
}

export async function fetchRegions(country = null, type = 'company_management', includes = []) {
  const params = {
    filter_groups: []
  }
  country = country || getCountry()
  if (country !== null) {
    params.filter_groups.push({
      filters: [
        ['country_iso_code', 'eq', country]
      ]
    })
  }
  if (type) {
    params.filter_groups.push({
      filters: [
        ['type', 'eq', type]
      ]
    })
  }
  if (includes.length > 0) {
    params.includes = includes
  }
  return Vue.http.get(appConfig.api.baseUrl + 'regions', {params})
}

export async function fetchAreas(country = null, includes = [], prevItems = [], page = 0) {
  let params = {}
  country = country || getCountry()
  if (country !== null) {
    params = {
      filter_groups: [{
        filters: [
          ['country', 'eq', country]
        ]
      }]
    }
  }
  if (includes.length > 0) {
    params.includes = includes
  }
  params.sort = [
    {
      key: 'name',
      direction: 'asc'
    }
  ]
  params.page = page
  return Vue.http.get(appConfig.api.baseUrl + 'areas', {params})
}

export async function fetchRoutingZones(country = null, includes = [], prevItems = [], page = 0) {
  let params = {}
  country = country || getCountry()
  if (country !== null) {
    params = {
      filter_groups: [{
        filters: [
          ['country_iso_code', 'eq', country]
        ]
      }]
    }
  }
  if (includes.length > 0) {
    params.includes = includes
  }
  params.sort = [
    {
      key: 'name',
      direction: 'asc'
    }
  ]
  params.page = page
  return Vue.http.get(appConfig.api.baseUrl + 'routing-zones', {params})
}

export async function fetchWarehouses(country = null, includes = []) {
  let params = {}
  country = country || getCountry()
  if (country !== null) {
    params = {
      filter_groups: [{
        filters: [
          ['country_iso_code', 'eq', country]
        ]
      }]
    }
  }
  if (includes.length > 0) {
    params.includes = includes
  }
  return Vue.http.get(appConfig.api.baseUrl + 'warehouses', {params})
}

// Mismo GET que fetchWarehouses: en la fachada difieren solo en qué props asignan.
export { fetchWarehouses as fetchWarehousesById }

export async function fetchShippingSizes() {
  const params = {
    params: {
      sort: [{
        key: 'max_weight',
        direction: 'asc'
      }]
    }
  }
  return Vue.http.get(appConfig.api.baseUrl + 'sizes', params)
}

export async function fetchShippingTypes() {
  const params = {
    params: {
      sort: [{
        key: 'name',
        direction: 'asc'
      }]
    }
  }
  return Vue.http.get(appConfig.api.baseUrl + 'shipping-types', params)
}

export async function fetchPlatforms() {
  const params = {
    params: {
      sort: [{
        key: 'name',
        direction: 'asc'
      }]
    }
  }
  return Vue.http.get(appConfig.api.baseUrl + 'platforms', params)
}

export async function fetchVehicleTypes() {
  const params = {
    params: {
      sort: [{
        key: 'max_volume_allowed',
        direction: 'asc'
      }]
    }
  }
  return Vue.http.get(appConfig.api.baseUrl + 'vehicle-types', params)
}

export async function fetchRoles(setDisabledsByRole = false) {
  const params = {
    params: {
      sort: [{
        key: 'name',
        direction: 'asc'
      }]
    }
  }
  return Vue.http.get(appConfig.api.baseUrl + 'roles', params)
}

export async function fetchReceiverTypes() {
  return Vue.http.get(appConfig.api.baseUrl + 'receiver-types')
}

export async function fetchShippingStatusReasons() {
  return Vue.http.get(appConfig.api.baseUrl + 'shipping-status-reasons')
}

export async function fetchEventTypes() {
  const params = {
    params: {
      sort: [{
        key: 'name',
        direction: 'asc'
      }]
    }
  }
  return Vue.http.get(appConfig.api.baseUrl + 'event-types', params)
}

export async function fetchNotificationTypes() {
  const params = {
    params: {
      sort: [{
        key: 'name',
        direction: 'asc'
      }]
    }
  }
  return Vue.http.get(appConfig.api.baseUrl + 'notification-types', params)
}

export async function fetchIndustries() {
  const params = {
    // sort: [{
    //   key: 'description',
    //   direction: 'asc'
    // }],
    filter_groups: [
      {
        filters: [
          ['type', 'eq', 'industry']
        ]
      }
    ]
  }
  return Vue.http.get(appConfig.api.baseUrl + 'marketing-catalogs', {params})
}

export async function fetchCompaniesSettings() {
  const params = {
    params: {
      sort: [{
        key: 'name',
        direction: 'asc'
      }]
    }
  }
  return Vue.http.get(appConfig.api.baseUrl + 'settings', params)
}

export async function fetchCompaniesSegments() {
  const params = {
    params: {
      sort: [{
        key: 'id',
        direction: 'asc'
      }]
    }
  }
  return Vue.http.get(appConfig.api.baseUrl + 'companies-segments', params)
}

export async function fetchDisableReasons() {
  const params = {
    params: {
      sort: [{
        key: 'name',
        direction: 'asc'
      }]
    }
  }
  return Vue.http.get(appConfig.api.baseUrl + 'disable-reasons', params)
}

export async function fetchServices() {
  return Vue.http.get(appConfig.api.baseUrl + 'services')
}

export async function fetchOutsourcingModelMappings() {
  return Vue.http.get(appConfig.api.baseUrl + 'outsourcing-model-mappings/mapeable-models')
}

export async function fetchPlatforms3p() {
  const params = {
    sort: [{
      key: 'name',
      direction: 'asc'
    }],
    filter_groups: [{
      filters: [
        ['name', 'ct', '[3p]']
      ]
    }]
  }
  return Vue.http.get(appConfig.api.baseUrl + 'platforms', {params})
}

export async function fetchOutsourcingCustomizations() {
  return Vue.http.get(appConfig.api.baseUrl + 'outsourcing/customizations')
}

// Catálogos contables por país (view_company / view_user declaran su lista de catalog).
export async function fetchAccountingCatalogs(countryIsoCode, catalogs) {
  const params = {
    sort: [{
      key: 'name',
      direction: 'asc'
    }],
    filter_groups: [{
      filters: [
        ['country_iso_code', 'eq', countryIsoCode],
        ['catalog', 'in', catalogs]
      ]
    }]
  }
  return Vue.http.get(appConfig.api.baseUrl + 'accounting-catalogs', {params})
}
